import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import {
  cancelOrderFn,
  type CancelOrderRequestBody,
  type CancelOrderOptions,
} from './cancel-order-fn';

export const useCancelOrder = (
  opts?: UseMutationOptions<
    NonNullable<unknown>,
    DefaultQueryError,
    { body: CancelOrderRequestBody; options?: CancelOrderOptions }
  >
) =>
  useMutation<
    NonNullable<unknown>,
    DefaultQueryError,
    { body: CancelOrderRequestBody; options?: CancelOrderOptions }
  >({
    mutationFn: ({ body, options }) => cancelOrderFn(body, options),
    ...opts,
  });
